<template>
  <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on"  text>{{getName($store.state.current.period)}}<v-icon>mdi-chevron-down</v-icon></v-btn>
    </template>
    <v-list>
        <v-list-item @click="selectPeriod(per)" v-for="per in $store.getters['current/getPeriods']" :key="per.id" link>{{getName(per)}}</v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import translateService from '@/helper/translateService.js'
//import periodServices from '@/services/periodServices.js'
export default {
  methods:{
    selectPeriod(period){
      this.$store.commit('current/setPeriod', period);
      this.$emit('update', period);
    },
    getName(item){
      return translateService.getName(item.names)
    },
    async resolveDefaultIfNeeded() {
        // Si ya hay periodo seleccionado, no hacer nada
        if (this.$store.state.current.period && this.$store.state.current.period.id) return;

        const sectorId = this.$store.state.current.sector && this.$store.state.current.sector.id;
        const stageId = this.$store.state.current.stage && this.$store.state.current.stage.id;
        if (!sectorId || !stageId) return;

        try {
            // PRIMERO intentar con el período actual
            const currentResp = await periodServices.getCurrentPeriod();
            if (currentResp.data && currentResp.data.id) {
                const list = this.$store.getters['current/getPeriods'] || [];
                const found = list.find(p => p.id === currentResp.data.id);
                if (found) {
                    this.selectPeriod(found);
                    return;
                }
            }
        } catch (error) {
            // Continuar con la lógica existente si falla
            console.log('No se pudo obtener período actual');
        }

        // LUEGO intentar con el período por defecto del sector (lógica existente)
        try {
            const resp = await periodServices.getDefaultPeriodForSector(sectorId);
            const defaultId = resp.data.periodId;
            const list = this.$store.getters['current/getPeriods'] || [];
            const found = list.find(p => p.id === defaultId) || list[0];
            if (found) this.selectPeriod(found);
        } catch {
            const list = this.$store.getters['current/getPeriods'] || [];
            if (list.length) this.selectPeriod(list[0]);
        }
    }
  },
  async created() {
    await this.resolveDefaultIfNeeded();
  }
}
</script>

<style>

</style>